import i18n from '../i18n/index'
import { readFunctionError } from './functionErrors'

export async function normalizeErrorMessage(error: unknown): Promise<string> {
  if (error instanceof Error) return error.message
  if (typeof error === 'string') return error
  return await readFunctionError(error)
}

export function getUserFriendlyMessageFromText(message: string): string {
  const lower = message.toLowerCase()

  if (lower.includes('subscription') || lower.includes('restore') || lower.includes('billing sync')) {
    return i18n.t('app.errors.noActiveSubscription')
  }
  if (lower.includes('timeout') || lower.includes('network') || lower.includes('fetch')) {
    return i18n.t('app.errors.network')
  }
  if (lower.includes('auth') || lower.includes('unauthorized') || lower.includes('jwt')) {
    return i18n.t('app.errors.sessionExpired')
  }

  return i18n.t('app.errors.generic')
}

export async function getUserFriendlyMessage(error: unknown): Promise<string> {
  const message = await normalizeErrorMessage(error)
  return getUserFriendlyMessageFromText(message)
}
